import $ from 'jquery';
import './Tracking.mjs';

export default class CompliancePortal {
  constructor() {
    const $compliancePortalContainer = $('.tx-mw-compliance-portal');
    const $table = $compliancePortalContainer.find('table').first();

    /**
     * open file on table->tr click
     */
    $table.find("tr").not(':first').click(function(e) {
      const $ATagToFile = $(this).find('td a.filelink').first();
      window.open($ATagToFile.attr('href'), '_blank');
    });
  }
}
